/**
 * Physical stores that stock Dutch Passion seeds in Thailand.
 *
 * Structured data rather than page content: it is a list of records with a
 * consistent shape, and keeping it as an array means the page can group, sort
 * or filter without anyone re-editing markup.
 *
 * Logos live in `static/media/`. Map links are the short `maps.app.goo.gl`
 * URLs the live site uses.
 */

export interface Reseller {
	name: string;
	address: string;
	/** Google Maps short link. */
	mapUrl: string;
	/** Path under `static/`, e.g. `/media/highcraft.webp`. */
	logo: string;
}

export interface ResellerCity {
	city: string;
	stores: Reseller[];
}

export const RESELLERS: ResellerCity[] = [
	{
		city: 'Bangkok',
		stores: [
			{
				name: 'Highcraft Thailand Dispensary',
				address: '8-8/1-2 Ratchadaphisek Rd, Khlong Toei, Bangkok 10110',
				mapUrl: 'https://maps.app.goo.gl/ympCKY1Pq3JEriF49',
				logo: '/media/highcraft.webp'
			},
			{
				name: 'Izumo Green',
				address: '18/8 Sukhumvit 21 Rd, Khlong Toei Nuea, Watthana, Bangkok 10110',
				mapUrl: 'https://maps.app.goo.gl/yNEeF6eG439YdWTR7',
				logo: '/media/izumogreenlogo.webp'
			},
			{
				name: 'Wonderland',
				address: 'Soi Sukhumvit 5, Khwaeng Khlong Toei Nuea, Watthana, Bangkok 10110',
				mapUrl: 'https://maps.app.goo.gl/ELCDBj9aCR8RaX9N8',
				logo: '/media/wonderlandlogo.webp'
			},
			{
				name: 'Cloud Nine Asoke',
				address: '221 Sukhumvit Rd, Khlong Toei Nuea, Watthana, Bangkok 10110',
				mapUrl: 'https://maps.app.goo.gl/HmZJCABsbTsqtjV57',
				logo: '/media/cloudnineasokelogo.webp'
			},
			{
				name: 'Cloud Nine Surawong',
				address: '178 Surawong Rd, Si Phraya, Bang Rak, Bangkok 10500',
				mapUrl: 'https://maps.app.goo.gl/9q815FSbsZUbtvXf7',
				logo: '/media/cloudninesurawonglogo.webp'
			},
			{
				name: 'Mary Jane Nana',
				address: '106 Sukhumvit Rd, Khwaeng Khlong Toei, Khlong Toei, Bangkok 10110',
				mapUrl: 'https://maps.app.goo.gl/KEXgkAsLSX9AsRs3A',
				logo: '/media/maryjanelogo.webp'
			},
			{
				name: 'Kush House',
				address: '1 Sukhumvit Alley 22, Klongton, Khlong Toei, Bangkok 10110',
				mapUrl: 'https://maps.app.goo.gl/DCqQngw79kZwtcXx7',
				logo: '/media/kushhouselogo.webp'
			}
		]
	},
	{
		city: 'Phuket',
		stores: [
			{
				name: 'GrowLand',
				address: '82 26 Rawai, Mueang Phuket District, Phuket 83100',
				mapUrl: 'https://maps.app.goo.gl/havkpRBby36a1ubm8',
				logo: '/media/growlandlogo.webp'
			}
		]
	},
	{
		city: 'Krabi',
		stores: [
			{
				name: 'Ganja House',
				address:
					'441/1 Moo 1, Klong Dao, Thambon Saladan, Amphoe Koh Lanta Yai Ban, Ban, Ko Lanta District, Krabi 81150',
				mapUrl: 'https://maps.app.goo.gl/BZBVhmegtqmNDo7n8',
				logo: '/media/ganjahouselogo.webp'
			}
		]
	}
];
